import type { SVGProps } from "react";
// generated from Warning.svg — do not edit manually
// prettier-ignore
export default function Warning(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M11.8667 7.6V11.8667M11.8667 14V16.1333M22.5333 11.8667C22.5333 17.7578 17.7578 22.5333 11.8667 22.5333C5.97563 22.5333 1.2 17.7578 1.2 11.8667C1.2 5.97563 5.97563 1.2 11.8667 1.2C17.7578 1.2 22.5333 5.97563 22.5333 11.8667Z" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
